import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { SignUpPayload } from "../type";

function useSignUp() {
  return useMutation({
    mutationFn: (command: SignUpPayload) => {
      return authService.SignUp(command);
    },
  });
}

export default useSignUp;
